var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncreaseIndentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.51893 10.0007L1.8254 6.9025C1.61289 6.65806 1.61289 6.26175 1.8254 6.01731C2.03791 5.77288 2.38247 5.77288 2.59498 6.01731L5.6733 9.55806C5.88581 9.8025 5.88581 10.1988 5.6733 10.4432L2.59498 13.984C2.38247 14.2284 2.03791 14.2284 1.8254 13.984C1.61289 13.7396 1.61289 13.3432 1.8254 13.0988L4.51893 10.0007Z",
    fill: "#7A7A7A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83398 5.20898C5.83398 4.86381 6.11381 4.58398 6.45898 4.58398H16.8757C17.2208 4.58398 17.5007 4.86381 17.5007 5.20898C17.5007 5.55416 17.2208 5.83398 16.8757 5.83398H6.45898C6.11381 5.83398 5.83398 5.55416 5.83398 5.20898Z",
    fill: "#7A7A7A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 10.209C7.5 9.86381 7.77982 9.58398 8.125 9.58398L18.5417 9.58398C18.8868 9.58398 19.1667 9.86381 19.1667 10.209C19.1667 10.5542 18.8868 10.834 18.5417 10.834L8.125 10.834C7.77982 10.834 7.5 10.5542 7.5 10.209Z",
    fill: "#7A7A7A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83398 15.209C5.83398 14.8638 6.11381 14.584 6.45898 14.584H16.8757C17.2208 14.584 17.5007 14.8638 17.5007 15.209C17.5007 15.5542 17.2208 15.834 16.8757 15.834H6.45898C6.11381 15.834 5.83398 15.5542 5.83398 15.209Z",
    fill: "#7A7A7A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncreaseIndentIcon);
export default __webpack_public_path__ + "static/media/increase_indent_icon.7c8f0bd84fff6857b969c62386891c27.svg";
export { ForwardRef as ReactComponent };